import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

// Loads full settings, lets a page edit one section and save it back.
export function useSettingsSection() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)); }, []);

  const save = async (partial) => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings", partial);
      setSettings(data);
      toast.success("Saved successfully");
      return true;
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail, "Failed to save"));
      return false;
    } finally { setSaving(false); }
  };

  return { settings, setSettings, save, saving };
}
